import { client } from "../client";

export const getAuthConfig = async () => {
  const resp = await client.get("/oauth2client/config");
  return resp.data;
};
